import { Component, OnInit, Input, forwardRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ReportOption } from 'app/core/models/report-option.model';
import { ReportAbstractOptionComponent } from 'app/shared/components/report-abstract-option/report-abstract-option.component';
import { User } from 'app/core/models/user.model';
import { NgSelectComponent } from '@ng-select/ng-select';
import { UsersService } from '../../../core/services/users.service';
import { UserType } from '../../../core/enums/user-type.enum';

export class ReportUsersOption implements ReportOption {
  value: User[];

  constructor(value: User[]) {
    this.value = value;
  }

  toPostData(options = { paramName: 'userIds' }) {
    return { [options.paramName]: this.value };
  }
}

@Component({
  selector: 'app-report-users-option',
  templateUrl: './report-users-option.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ReportUsersOptionComponent),
    },
  ],
  imports: [NgSelectComponent, FormsModule]
})
export class ReportUsersOptionComponent extends ReportAbstractOptionComponent implements OnInit {
  private usersService = inject(UsersService);

  @Input() label = 'Filter by Users';
  @Input() multiple = true;

  selectedUsers: User[];
  users: User[];

  ngOnInit() {
    this.loadUsers();
  }

  private loadUsers() {
    this.usersService.getByUserType([UserType.captureAdmin]).subscribe(result => {
      this.users = result.users;
    });
  }

  protected updateInternalState(model: ReportUsersOption) {
    if (model) {
      this.selectedUsers = model.value;
    }
  }

  protected determineModelStateOnChange(): ReportUsersOption {
    if (this.selectedUsers && (!Array.isArray(this.selectedUsers) || this.selectedUsers.length > 0)) {
      return new ReportUsersOption(this.selectedUsers);
    } else {
      return null;
    }
  }
}
